module.exports = __webpack_public_path__ + "static/media/gy.acaaaf52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gy.png
// module id = 1872
// module chunks = 0